import { buttonRecipe } from "./button";
export const recipes = {
  button: buttonRecipe,
};
